import React from 'react'
import { FaDatabase } from 'react-icons/fa'
import { StepCard, StepHeader, StepContent, SourceGroup } from './ModelTrainingView.styles'
import PillsDataset from '../../PillsDataset'
import { Model } from '../../../types/models/model'

interface DataSourcesCardProps {
  model: Model | undefined
  gradient: string
}

const DataSourcesCard: React.FC<DataSourcesCardProps> = ({ model, gradient }) => {
  return (
    <StepCard style={{ flex: 1 }}>
      <StepHeader $gradient={gradient}>
        <FaDatabase />
        Data Sources
      </StepHeader>
      <StepContent>
        <SourceGroup>
          <div className="source-label">Training Dataset</div>
          <div className="dataset-container">
            <PillsDataset
              datasetNames={model?.parameters?.train_metadata?.datasource || []}
              tiny={false}
            />
          </div>
        </SourceGroup>
        <SourceGroup style={{ marginBottom: 0 }}>
          <div className="source-label">Validation Dataset</div>
          <div className="dataset-container">
            <PillsDataset
              datasetNames={model?.parameters?.validation_metadata?.datasource || []}
              tiny={false}
            />
          </div>
        </SourceGroup>
        {/* <SourceGroup>
          <div className="source-label">Tag Filter</div>
          <div className="dataset-container">
            <PillsDataset
              datasetNames={['landuse', 'building', 'water', 'road', 'vegetation', 'other']}
              tiny={true}
            />
          </div>
        </SourceGroup> */}
      </StepContent>
    </StepCard>
  )
}

export default DataSourcesCard
